import React, { useMemo, useState } from "react";
import "./MathCrossword.css";

const OPS = ["+", "-", "×", "÷"];

function toNum(s) {
  if (s === "" || s === "-" || s == null) return NaN;
  return Number(s);
}

function rowStatus([A, op, B, _eq, C]) {
  const a = toNum(A), b = toNum(B), c = toNum(C);
  if ([a, b, c].some(Number.isNaN)) return "idle";

  switch (op) {
    case "+": return (a + b === c) ? "ok" : "bad";
    case "-": return (a - b === c) ? "ok" : "bad";
    case "×": return (a * b === c) ? "ok" : "bad";
    case "÷":
      if (b === 0) return "bad";
      return (a / b === c) ? "ok" : "bad";
    default: return "bad";
  }
}

export default function MathCrossword() {
  const initial = [
    [19, "-", 15, "=", 4],
    [50, "-", 30, "=", 20],
    ["", "-", 78, "=", 20],
    ["", "×", 3, "=", 126],
    ["", "×", "", "=", 30],
    ["", "÷", "", "=", 17],
    ["", "÷", 3, "=", 98],
    [894, "÷", "", "=", 298],
  ];

  const [grid, setGrid] = useState(initial);

  const statuses = useMemo(() => grid.map(rowStatus), [grid]);
  const allCorrect = statuses.length > 0 && statuses.every(s => s === "ok");

  const update = (r, c, v) => {
    let s = v.replace(/[^\d-]/g, "");
    if (s.includes("-")) {
      s = (s[0] === "-" ? "-" : "") + s.replace(/-/g, "");
    }
    setGrid(prev => {
      const copy = prev.map(row => [...row]);
      copy[r][c] = s;
      return copy;
    });
  };

  const isEditable = (val) => !(OPS.includes(val) || val === "=");

  return (
    <div className="mcw-container">
      {grid.map((row, r) => (
        <div key={r} className="mcw-row-simple" data-status={statuses[r]}>
          {row.map((cell, c) => {
            const isOp = OPS.includes(cell) || cell === "=";
            return (
              <div
                key={c}
                className={`mcw-box ${isOp ? "mcw-box-op" : ""}`}
              >
                {isEditable(cell) ? (
                  <input
                    className="mcw-input"
                    value={String(cell)}
                    inputMode="numeric"
                    pattern="-?[0-9]*"
                    placeholder="?"
                    onChange={(e) => update(r, c, e.target.value)}
                  />
                ) : (
                  <span className="mcw-static">{cell}</span>
                )}
              </div>
            );
          })}
        </div>
      ))}

      {allCorrect && (
        <div className="mcw-success">
          🎉 Great job! All equations are correct!
        </div>
      )}

      <p className="mcw-note">
        Fill in the empty boxes. Rows turn green when correct and red if wrong.
        Only numbers (optionally a leading minus) are accepted.
      </p>
    </div>
  );
}